import { render } from "./ProgressRing.vue?vue&type=template&id=8a2b12f0&scoped=true"
import script from "./ProgressRing.vue?vue&type=script&lang=js"
export * from "./ProgressRing.vue?vue&type=script&lang=js"

import "./ProgressRing.vue?vue&type=style&index=0&id=8a2b12f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8a2b12f0"

export default script